let body = document.querySelector('body');

let body_observer = new MutationObserver(
    function (mutations, observer) {
        for (const mutation of mutations) {
            if (mutation.type === 'childList') {
                window.dispatchEvent(new Event('body-change'));
            }
        }
    }
);

body_observer.observe(body, { childList: true });
